/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { TrainingServiceStatus } from 'src/modules/modelTraining/types/trainingTypes';

type UseModelTrainingUpdateProps = {
    currentProjectStore: { trainingServiceStatus: TrainingServiceStatus };
    onUpdateTrainedModels: () => void;
};
export const useModelTrainingUpdate = (props: UseModelTrainingUpdateProps) => {
    const { currentProjectStore, onUpdateTrainedModels } = props;

    const [trainingStatus, setTrainingStatus] = React.useState<TrainingServiceStatus>(null);

    React.useEffect(() => {
        if (currentProjectStore?.trainingServiceStatus !== trainingStatus && trainingStatus === 'inProgress') {
            onUpdateTrainedModels();
        }

        setTrainingStatus(currentProjectStore?.trainingServiceStatus);
    }, [currentProjectStore, currentProjectStore?.trainingServiceStatus]);
};
